export const status = [
  { id: 1, name: "Active", value: "Active" },
  { id: 2, name: "Deactive", value: "Deactive" },
];

export const sites = [
  { id: 1, name: "Travomint-Vaccations", value: 1 },
  { id: 2, name: "ReservationsDeal-Vaccations", value: 2 },
];
